import { render, staticRenderFns } from "./LoFPerLanguageDrilldown.vue?vue&type=template&id=1fae1656&"
import script from "./LoFPerLanguageDrilldown.vue?vue&type=script&lang=js&"
export * from "./LoFPerLanguageDrilldown.vue?vue&type=script&lang=js&"
import style0 from "./LoFPerLanguageDrilldown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports